import { apiClient } from "./client";

type ApiEnvelope<T> = {
  success: boolean;
  message?: string;
  data?: T;
};

export type CmsPage = {
  slug: string;
  title: string;
  content: string;
};

export async function getCmsPage(slug: string): Promise<CmsPage> {
  const { data } = await apiClient.get<ApiEnvelope<CmsPage>>(`/cms/${slug}`);
  if (!data.success || !data.data) {
    throw new Error(data.message ?? "Failed to load page");
  }
  return data.data;
}
